import React from 'react';
import { FaTimes, FaCheck, FaCrown, FaHandshake, FaArrowRight } from 'react-icons/fa';

const UpgradeModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const proFeatures = [
    "360° Financial Dashboard & Goal Tracker",
    "Scientific Gap Analysis & Net Worth Snapshot",
    "AI-Powered Smart Insights",
    "Money Meter — Income, Expenses & Cash Leaks",
    "Financial Education Modules (Money School)",
    "Arth Kundli — Goal-Based Financial Plan",
    "Child Future Ready Assessment",
    "Expert Consultant Reviews",
    "All Platform Updates & New Features"
  ];

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[60] flex items-center justify-center p-4" data-testid="upgrade-modal">
      <div className="bg-gradient-to-br from-[#1A2942] to-[#0F172A] rounded-2xl border border-[#FFD700]/30 shadow-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="relative p-6 pb-4 text-center border-b border-[#2D5A8F]/50">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors"
            data-testid="upgrade-modal-close"
          >
            <FaTimes size={18} />
          </button>
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-gradient-to-br from-[#FFD700] to-[#D4AF37] flex items-center justify-center shadow-lg shadow-[#FFD700]/20">
            <FaCrown className="text-[#0A1929] text-2xl" />
          </div>
          <h2 className="text-2xl font-bold text-white mb-1">Upgrade to a Paid Plan</h2>
          <p className="text-gray-400 text-sm">Unlock the full power of Arth Gurukul</p>
        </div>

        {/* Pricing */}
        <div className="px-6 pt-4">
          <div className="bg-[#FFD700]/10 border border-[#FFD700]/30 rounded-xl p-4 mb-4">
            <p className="text-center text-gray-400 text-xs uppercase tracking-wider mb-2">Membership starts at</p>
            <div className="flex items-center justify-center gap-2">
              <span className="text-3xl font-bold text-[#FFD700]">₹999</span>
              <span className="text-gray-400 text-sm">/ year + GST</span>
            </div>
            <p className="text-green-400 text-xs mt-1 font-medium text-center">DIY plan • Guided plan also available</p>
          </div>
          {/* Disclaimer */}
          <p className="text-[10px] text-gray-500 italic mb-3 border-l-2 border-[#FFD700]/30 pl-2 leading-relaxed" data-testid="upgrade-modal-disclaimer">
            The membership fee is for financial wellness education &amp; financial wellness tools only. No fees are charged by the platform for any consultation or advice by a financial consultant or planner.
          </p>
        </div>

        {/* Features */}
        <div className="px-6 py-3">
          <p className="text-gray-400 text-xs uppercase tracking-wider mb-3 font-medium">What you unlock</p>
          <div className="space-y-2.5">
            {proFeatures.map((feature) => (
              <div key={`feature-${feature.substring(0, 10)}`} className="flex items-start gap-2.5">
                <FaCheck className="text-[#FFD700] mt-0.5 flex-shrink-0 text-xs" />
                <span className="text-gray-300 text-sm">{feature}</span>
              </div>
            ))}
          </div>
        </div>

        {/* CTAs */}
        <div className="p-6 pt-4 space-y-3">
          <button
            onClick={onClose}
            data-testid="upgrade-talk-to-consultant-btn"
            className="w-full flex items-center justify-center gap-2 py-3 bg-gradient-to-r from-[#D4AF37] to-[#FFD700] text-[#0A1929] font-bold rounded-xl hover:from-[#FFD700] hover:to-[#D4AF37] transition-all shadow-lg shadow-[#FFD700]/20"
          >
            <FaHandshake />
            Talk to your consultant
            <FaArrowRight />
          </button>
          <p className="text-center text-gray-500 text-xs px-2">
            Contact details available on the website.
          </p>
          <button
            onClick={onClose}
            className="w-full text-center text-gray-500 text-xs py-2 hover:text-gray-400 transition-colors"
          >
            Maybe Later
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpgradeModal;
